import { render, staticRenderFns } from "./material.vue?vue&type=template&id=33ca894f&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=33ca894f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca894f",
  null
  
)

export default component.exports